import makeRoutes from "@/routes/Base/Route";

export default makeRoutes('coresectors').map(route => {
    return {
        ...route,
        meta: {perfil: 'root'}
    }
})